import React from "react";
import TabbedPage from "../../../../shared/ui/TabbedPage";
import StaffTab from "../../../staff/components/StaffTab";
import RulesTab from "../../components/RulesTab";
import FormulaTab from "../../components/FormulaTab";
import CoefficientsTab from "../../components/CoefficientsTab";

export default function CommissionsSettingsPage() {
  return (
    <TabbedPage
      title="تنظیمات پورسانت"
      defaultTab="staff"
      tabs={[
        { id: "staff", label: "پرسنل", component: StaffTab },
        { id: "rules", label: "قوانین پورسانت", component: RulesTab },
        { id: "formulas", label: "فرمول‌های محاسبه", component: FormulaTab },
        { id: "coefficients", label: "جداول ضرایب", component: CoefficientsTab },
        { id: "reports", label: "گزارشات", component: null },
        { id: "history", label: "تاریخچه", component: null },
      ]}
    />
  );
}
